import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/views/layout'
import annalsCollection from '@/views/collection/annalsCollection'
import dataCollection from '@/views/collection/dataCollection'//数据信息
import dataCollectionlist from '@/views/collection/dataCollectionList'//数据信息列表

import userManagement from '@/views/authorityManagement/userManagement'//用户管理

import roleManagement from '@/views/authorityManagement/roleManagement'//角色管理

import inforCollection from '@/views/collection/inforCollection'
import Home from '@/views/home/home'//主页面
import Login from '@/views/Login'//登录页面
import informationList from '@/views/home/informationList'
import informationDetail from '@/views/home/informationDetail'
import information from '@/views/home/information'//主页面


Vue.use(Router)

export default new Router({
  mode:'hash',
  routes: [
    {
      path: '/',
      component:Login,
      name:'login',
    },
    {
      path: '/Home',
      redirect: '/Home/home',
      component: layout,
      children:[
        {
          path: 'home',
          component:Home,
          name:'home',
        },
        {
          path: 'information',
          component:information,
          name:'information',
        },
        {
          path:'informationList',
          name:'informationlist',
          redirect:'informationList/1',
        },
        {
          path:'informationList/:startPage',
          component:informationList,
          name:'informationlist',
          meta: {
            keepAlive: true
          }
        },
        {
          path:'informationdetail',
          component:informationDetail,
          name:'informationdetail'
        },
      ]
    },
    {
      path: '/collection',
      redirect: '/collection/dataCollectionlist',
      component: layout,
      children: [
        {
          path: 'dataCollection',
          component:dataCollection,
          name:'datacollection',
        },
        {
          path: 'dataCollection1',
          component:dataCollection,
          name:'datacollection1',
        },
        {
          path: 'dataCollection2',
          component:dataCollection,
          name:'datacollection2',
        },
        {
          path: 'dataCollection3',
          component:dataCollection,
          name:'datacollection3',
        },
        {
          path: 'dataCollection4',
          component:dataCollection,
          name:'datacollection4',
        },
        {
          path: 'dataCollection5',
          component:dataCollection,
          name:'datacollection5',
        },
        {
          path:'dataCollectionList',
          name:'datacollectionlist',
          redirect:'dataCollectionList/1',
        },
        {
          path:'dataCollectionList/:startPage',
          component:dataCollectionlist,
          name:'datacollectionlist',
          meta: {
            keepAlive: true
          }
        },
      ]
    },
    {
      path: '/authorityManagement',
      redirect: '/authorityManagement/userManagement',
      component: layout,
      children: [
        {
          path: 'userManagement',
          component:userManagement,
          name:'usermanagement',
        },
        {
          path: 'roleManagement',
          component:roleManagement,
          name:'rolemanagement',
        },


      ]
    },
    {
      path: '/inforCollection',
      component:inforCollection,
      name:'信息采集',
    }, {
      path: '/annalsCollection',
      component:annalsCollection,
      name:'年报采集',
    }
  ]
})

//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js